import React from 'react';

const HeaderMobileCollapse = ({ data, toggleCollapsed }) => (
    <header onClick={() => {toggleCollapsed();}}>
        <i className="ficon ficon-chevron-down"></i>
        <h2 className="alt">{data.title}</h2>
        <span className={`star-rating-s15 rate-${data.rating_ten} p-l-10`}></span>
        <span className="total-rating-out-five">({data.rating_five})</span>
    </header>
);

export default HeaderMobileCollapse;


// WEBPACK FOOTER //
// ./src/reviews/headers/HeaderMobileCollapse.js